import { T } from "services/lang/LanguageService";
import { DashboardComponentPropsBase } from "components/pages/dashboard/components/interfaces";
import { ReportOptions } from "models/component-print-models";
import { IComponentTheme } from "../product-template-table/utils/interfaces";

export interface CurrentDateDisplayProps
  extends DashboardComponentPropsBase<ReportOptions>,
    IComponentTheme {
  year: YearTypes;
  month: MonthTypes;
  day: DayTypes;
}

export interface YearTypes {
  show: boolean;
  position?: Position;
  suffix?: string;
}

export interface MonthTypes {
  show: boolean;
  position?: Position;
  displayType?: MonthDisplayType;
}

export interface DayTypes {
  show: boolean;
  position?: Position;
}

export enum MonthDisplayType {
  NUMBER = "number",
  STRING_SHORT = "short",
  STRING_LONG = "long",
}

export enum Position {
  START = "start",
  MIDDLE = "middle",
  END = "end",
}

export enum TimeType {
  YEAR = "year",
  MONTH = "month",
  DAY = "day",
}

export const monthDisplayTypeOptions = [
  { label: T("word.number"), value: MonthDisplayType.NUMBER },
  { label: T("label.month-name-short"), value: MonthDisplayType.STRING_SHORT },
  { label: T("label.month-name-full"), value: MonthDisplayType.STRING_LONG },
];

export const allPositionOptions = [
  { label: T("layout.start"), value: Position.START },
  { label: T("word.middle"), value: Position.MIDDLE },
  { label: T("word.end"), value: Position.END },
];

export const twoPositionOptions = allPositionOptions.filter(p => p.value !== Position.MIDDLE);
